module.exports = __webpack_public_path__ + "img/user.e6f6556a.svg";